

export function buildTree(data) {
    let idMap = new Map();

    // First pass: store each node by its ID in a map and initialize children array
    if(data) {
        data.forEach(item => {
            let id = item.node.id;
            if (!idMap.has(id)) {
                idMap.set(id, { ...item.node, children: [] });
            }
        });
    
        // Second pass: assign each node to its parent's children array
        let root = [];
        data.forEach(item => {
            let node = idMap.get(item.node.id);
            if (item.node.parentId) {
                let parent = idMap.get(item.node.parentId);
                if (parent) {
                    parent.children.push(node);
                }
            } else {
                root.push(node);
            }
        });
    
        return root;
    }

    return null;

}

export function chunkArray(array, num) {
    const result = [];
    for (let i = 0; i < array?.length; i += num) {
        result.push(array.slice(i, i + num));
    }
    return result;
}

export const checkFileTypeByUrl = (url) => {
    const extension = url.split('.').pop().toLowerCase();
    if (extension === 'svg') {
      return 'svg';
    } else if (extension === 'jpg' || extension === 'jpeg' ) {
        return 'jpg';
    } else if (extension === 'png') {
      return 'png';
    } else {
      return 'unknown';
    }
  };



export const fetchInitialTheme = async () => {
    const response = await fetch('/api/theme');
    const data = await response.json();
    return data.theme;
};

export const flattenBlogApiData = (data) => {
    const { news, webinars, successStories } = data || {};
    const combinedNodes = [
      ...(news?.nodes || []),
      ...(webinars?.nodes || []),
      ...(successStories?.nodes || [])
    ];
    return combinedNodes;
}

export const convertUriToTagText = (uri) => {
    const tagMap = {
        'success-stories': 'Success Story',
        'webinars': 'Webinar',
        'project-thrive': 'Project Thrive',
        'insights': 'Industry Insights',
        'news': 'Company News',
    };

    for (const key in tagMap) {
        if (uri.includes(key)) {
            return tagMap[key];
        }
    }
    return 'Blog';
}

export function formatDate(inputDate) {
  try {
      const date = new Date(inputDate);
      const options = { year: 'numeric', month: 'short', day: '2-digit', timeZone: 'UTC' };
      return date.toLocaleDateString('en-US', options).replace(/ /g, ' ');
  } catch (e) {
      console.error(e);
      return inputDate;
  }
}

export const getDefaultFilename = (uri) => {
  const filenames = [
      "/default_blogs.jpg",
      "/default_podcast.png",
      "/default_insight.jpg",
      "/default_project-thrive.jpg",
      "/default_success-stories_1.jpg",
      "/default_success-stories_2.jpg",
      "/default_success-stories_3.jpg",
      "/default_success-stories_4.jpg",
      "/default_success-stories_5.jpg",
      "/default_success-stories_6.jpg",
      "/default_webinars.jpg",
      "/default_news.jpg"
  ];

  if (uri.includes('success-stories')) {
      // Get all success stories filenames
      const successStoryFilenames = filenames?.filter(filename => filename?.includes('success-stories'));
      // Return a random success stories filename
      
      return successStoryFilenames[Math?.floor(Math?.random() * successStoryFilenames?.length)];
  }

  return filenames.find(filename => {
      const substring = filename.split('_')[1].split('.')[0];
      return uri.includes(substring);
  }) || null; // Return null if no match is found
}